import {createActions} from 'client/framework';

export default createActions(null, ['TOGGLE_OPTION']);
